import TradeLyftMark from "./TradeLyftMark";
import styles from "./Brand.module.css";

function TradeLyftLockup({
  size = 64,
  animated = false,
  showWordmark = true,
  showTm = false,
  className,
}) {
  return (
    <div className={[styles.lockup, className].filter(Boolean).join(" ")}>
      <TradeLyftMark size={size} animated={animated} title={showWordmark ? undefined : "TradeLyft"} />
      {showWordmark ? (
        <span className={styles.wordmark} aria-label="TradeLyft">
          <span className={styles.wordmarkAccent}>T</span>
          rade
          <span className={styles.wordmarkAccent}>L</span>
          yft
          {showTm ? (
            <sup className={styles.tm} aria-hidden="true">
              ™
            </sup>
          ) : null}
        </span>
      ) : null}
    </div>
  );
}

export default TradeLyftLockup;
